import React from 'react';

const Tab = ({ children }) => (
  <div>{children}</div>
);

export default Tab;
